import { IFRAME_SANDBOX } from '@/pages/home/outputFiles';

type Props = {
  html: string | null;
};

export default function PreviewFrame({ html }: Props) {
  if (!html) {
    return (
      <div className="flex-1 w-full h-full flex items-center justify-center bg-white text-texts text-sm px-6 text-center">
        describe an outcome to see it
      </div>
    );
  }
  return (
    <iframe
      title="Compose preview"
      sandbox={IFRAME_SANDBOX}
      srcDoc={html}
      className="flex-1 w-full h-full bg-white"
    />
  );
}
